import React from 'react';
import SubpageHero from '../components/SubpageHero';
import BehandelingenIntro from '../components/BehandelingenIntro';
import TreatmentTypesSection from '../components/TreatmentTypesSection';
import TreatmentDetailsSection from '../components/TreatmentDetailsSection';
import BehandelingenApproachSection from '../components/BehandelingenApproachSection';
import BeforeAfterSlider from '../components/BeforeAfterSlider';
import ExpectationsSection from '../components/ExpectationsSection';
import FaqSection from '../components/FaqSection';
import { useBehandelingenHero } from '../hooks/useBehandelingenHero';
import { getCurrentLocale } from '../services/api';

const Behandelingen: React.FC = () => {
  const { data, loading, error } = useBehandelingenHero();
  const locale = getCurrentLocale();
  const isArabic = locale === 'ar';

  if (loading) {
    return (
      <div style={{ 
        height: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        fontSize: '18px'
      }}>
        Loading behandelingen page...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        height: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        color: 'red',
        fontSize: '18px'
      }}>
        Error: {error}
      </div>
    );
  }

  // Extract data from Strapi structure - handle both direct data and data.attributes
  const strapiData = data && (
    (data as any)?.data?.attributes || // If data has data.attributes structure
    data // If data is already the attributes (direct structure)
  );
  
  // Debug logging to see the exact data structure
  console.log('🔍 Behandelingen page - data:', data);
  console.log('🔍 Behandelingen page - strapiData:', strapiData);
  console.log('🔍 Behandelingen page - data structure:', {
    hasData: !!data,
    hasDataData: !!(data as any)?.data,
    hasDataAttributes: !!(data as any)?.data?.attributes,
    dataKeys: data ? Object.keys(data) : [],
    dataDataKeys: (data as any)?.data ? Object.keys((data as any).data) : [],
  });
  
  // Debug backgroundImage specifically
  console.log('🔍 Behandelingen page - backgroundImage:', strapiData?.backgroundImage);
  console.log('🔍 Behandelingen page - backgroundImage keys:', strapiData?.backgroundImage ? Object.keys(strapiData.backgroundImage) : []);
  console.log('🔍 Behandelingen page - backgroundImage.data:', strapiData?.backgroundImage?.data);
  console.log('🔍 Behandelingen page - backgroundImage.data.attributes:', strapiData?.backgroundImage?.data?.attributes);

  // If no data is available, show a default hero
  if (!strapiData) {
    return (
      <div>
        <div className="fallback-hero" style={{
          height: '560px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'flex-start',
          padding: '0 120px 80px 120px'
        }}>
          <h1 style={{
            fontFamily: 'var(--h1-font-family)',
            fontWeight: 'var(--h1-font-weight)',
            fontStyle: 'var(--h1-font-style)',
            fontSize: 'var(--h1-font-size)',
            lineHeight: 'var(--h1-line-height)',
            letterSpacing: 'var(--h1-letter-spacing)',
            color: 'white',
            margin: '0'
          }}>
            Behandelingen
          </h1>
        </div>
        
        <BehandelingenIntro />
        <TreatmentTypesSection />
        <TreatmentDetailsSection />
        <BehandelingenApproachSection />
        <BeforeAfterSlider />
        <ExpectationsSection />
      </div>
    );
  }

  return (
    <div dir={isArabic ? 'rtl' : 'ltr'}>
      <SubpageHero
        title={strapiData?.title || (isArabic ? 'العلاجات' : 'Behandelingen')}
        backgroundMedia={
          strapiData?.backgroundImage?.data?.attributes?.url
            ? {
                url: strapiData.backgroundImage.data.attributes.url,
                alternativeText: strapiData.backgroundImage.data.attributes.alternativeText,
              }
            : strapiData?.backgroundImage?.url
            ? {
                url: strapiData.backgroundImage.url,
                alternativeText: strapiData.backgroundImage.alternativeText,
              }
            : undefined
        }
        mediaType={strapiData?.mediaType}
        videoUrl={strapiData?.videoUrl}
        overlayOpacity={strapiData?.overlayOpacity}
        textColor={strapiData?.textColor}
        paddingBottom={strapiData?.paddingBottom}
        paddingLeft={strapiData?.paddingLeft}
        paddingRight={strapiData?.paddingRight}
      />
      
      <BehandelingenIntro />
      <TreatmentTypesSection />
      <TreatmentDetailsSection />
      <BehandelingenApproachSection />
      <BeforeAfterSlider />
      <ExpectationsSection />
      <FaqSection />
    </div>
  );
};

export default Behandelingen; 